import { create } from 'axios';
import * as types from './ActionTypes';
import { applyOrgFilter } from './filter.action';
import { getOrganizations } from './organizations.action';
import { addToast } from './toast.action';

const ajax = create({
  contentType: 'application/json',
  baseURL: process.env.REACT_APP_CORE_USER_API_URL,
  withCredentials: true
});

export const updateOrgName = orgData => {
  const { childOrgKey: externalKey, newChildOrgName: displayName } = orgData;
  return ajax.put(`/organizations/${externalKey}`, { displayName });
};

export async function getSpecifiedRelationships(uuid) {
  try {
    const organization = await ajax.get(`/organizations/${uuid}?attachRelationships=true`);

    return organization.data.relationships;
  } catch (err) {
    return err;
  }
}

export const updateOrgRelationships = ultimateObject => async dispatch => {
  try {
    dispatch({ type: types.UPDATE_RELATIONSHIPS_PENDING });

    let {
      newData,
      oldOrgData,
      relData: relTypes,
      currentOrgData
    } = ultimateObject;

    let newRelationshipTypeND = relTypes.new.value;

    if (!newRelationshipTypeND) {
      newRelationshipTypeND = '';
    }

    if (currentOrgData.newChildOrgName) {
      try {
        dispatch({ type: types.UPDATE_ORGANIZATION_NAME_PENDING });

        updateOrgName(currentOrgData);

        dispatch({ type: types.UPDATE_ORGANIZATION_NAME_SUCCESS });
      } catch (err) {
        dispatch({ type: types.UPDATE_ORGANIZATION_NAME_REJECTED });
      }
    }

    // **************************************************************************************
    /* We don't have access to all the relationships at once because the orgs page really
     * renders org-relationship_type pairs, (not the full org) so we need to build the new
     * state object in two parts.
     * 1. The portion that is not available to edit on rendered Wizard because they are of
     *    a separate relationship_type.
     * 2. The portion that is editable on the rendered Wizard */
    const originalRelationshipState = oldOrgData.map(r => {
      if (r.partyType === 'ORGANIZATION') {
        return {
          toPartyKey: r.hierarchy === 'parent' ? currentOrgData.childOrgKey : r.externalKey,
          fromPartyKey: r.hierarchy === 'parent' ? r.externalKey : currentOrgData.childOrgKey,
          relationshipType: r.relationshipType
        };
      } else if (r.partyType === 'PERSON') {
        return {
          fromPartyKey: currentOrgData.childOrgKey,
          toPartyKey: r.externalKey,
          relationshipType: r.relationshipType
        };
      } else {
        throw new Error('oldOrgData includes a partyType that is not either PERSON or ORGANIZATION');
      }
    });

    const newRelationshipState = []; // what we will use in our state update body

    /* 1. First we need to add everything that's not visible on the current page
     * to the newRelationshipState obj. */
    originalRelationshipState.forEach(r => {
      /* if the relationship type doesn't match the relType.original (which
       * is simply the rel type shown on the edit page when we first render)
       * then we know it can't be edited on this page and that it will remain
       * in the new relationship state.*/
      if (r.relationshipType !== relTypes.original.value) {
        newRelationshipState.push(r); // These are the untouched relationships
      }
    });

    /* 2. Then we need to add all the new relationships from the current Wizard  */
    newData.forEach(r => {
      newRelationshipState.push({
        toPartyKey: currentOrgData.childOrgKey,
        fromPartyKey: r.value,
        relationshipType: relTypes.new.value
      });
    });

    await ajax.put(`/relationships/state/${currentOrgData.childOrgKey}`, { newRelationshipState });

    dispatch({ type: types.UPDATE_RELATIONSHIPS_SUCCESS });
    dispatch(applyOrgFilter(null));
    dispatch(
      addToast({
        autohide: true,
        toasts: [{
          action: 'dismiss',
          text: `${currentOrgData.newChildOrgName || currentOrgData.childOrgName} has been edited`
        }]
      })
    );
    await dispatch(getOrganizations());

  } catch (error) {
    dispatch({
      type: types.SET_ERROR_DIALOG,
      payload: {
        error,
        visible: true
      }
    });
    dispatch(applyOrgFilter(null));
    dispatch({ type: types.UPDATE_RELATIONSHIPS_REJECTED });

    return error.message;
  }
};



// WEBPACK FOOTER //
// ./src/actions/relationships.action.js